import React from 'react';
import { SPORT_ICONS } from '../../../constants/defaultValues';
import styles from './Sport.module.scss';

const Sport = ({ sportId, isActive, className }) => {
    const SportIcon = SPORT_ICONS[sportId];

    return SportIcon ? (
        <SportIcon className={`${styles.icon} ${className} ${isActive ? styles.active : ''}`} />
    ) : null;
};

export default Sport;
